@if (shouldShowErrors()) {
  <div class="text-danger">
    @for (error of listOfErrors(); track $index) {
      <small class="text-danger" [style.font-size.rem]="0.75">
        {{ error }}
      </small>
    }
  </div>
}
